import { campaignSet } from '@civitime/game-server/lib/saga-tools/Data.effects'

export function* leaderboardSent(event) {
  yield campaignSet(`leaderboards/leaderboard/${event?.target}`, event?.points)
  return
}
export function* finalLeaderboardSent(event) {
  yield campaignSet(`states/${event?.target}/finalLeaderboard`, () => true)
  return
}